<template>
  <vx-card v-show="isCardActiveLocal" title="Quiz Details" class="mb-4">
    <div class="vx-row">
      <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
        <table>
          <tr><td><p>Title:</p></td><td><p style="font-weight: 700">{{ quiz.title }}</p></td></tr>
          <tr><td><p>Description:</p></td><td><p style="font-weight: 700">{{ quizDescription }}</p></td></tr>
          <tr><td><p>Grade Type:</p></td><td><p :style="{ 'color': setColor(quiz.isGraded), 'font-weight': 700 }">{{ quiz.isGraded ? 'Graded' : 'Survey' }}</p></td></tr>
          <tr v-if="quiz.isGraded"><td><p>Total:</p></td><td><p :style="{ 'font-weight': 700 }">{{ newQuizTotal }}</p></td></tr>
          <tr><td><p>Is Journal:</p></td><td><p :style="{ 'color': setColor(quiz.isJournal), 'font-weight': 700 }">{{ quiz.isJournal ? 'Yes' : 'No' }}</p></td></tr>
          <tr v-if="quiz.isGraded"><td><p>Pass Percentage:</p></td><td><p :style="{'font-weight': 700 }">{{ quiz.passPercentage > 0 ? quiz.passPercentage + '%' : 'N/A' }}</p></td></tr>
          <tr><td><p>Time Limit:</p></td><td><p :style="{ 'color': setColor(quiz.timeLimit), 'font-weight': 700 }">{{ quiz.timeLimit == 0 ? 'None' : quiz.timeLimit + ' minutes' }}</p></td></tr>
        </table>
      </div>
      <div v-if="quiz.imageUrl" class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
        <img :src="quiz.imageUrl" width="100%" alt="Quiz Image">
      </div>
    </div>
    <div v-if="quiz.isGraded">
      <vs-divider position="left-center"><strong>Summary</strong></vs-divider>
      <div class="vx-row">
        <div class="vx-col w-full">
          <table>
            <!-- <tr v-if="newScore != info.marksScored"><td><p>Original Score:</p></td><td><p style="font-weight: 700">{{ quizInfo.summary.score }}</p></td></tr>
            <tr v-else><td><p>Score:</p></td><td><p style="font-weight: 700">{{ quizInfo.summary.score }}</p></td></tr>

            <tr v-if="newScore != info.marksScored"><td><p>Original Percentage:</p></td><td><p style="font-weight: 700">{{ info.achievedPercentage }}%</p></td></tr>
            <tr v-else><td><p>Percentage:</p></td><td><p style="font-weight: 700">{{ info.achievedPercentage }}%</p></td></tr>

            <tr v-if="newScore != info.marksScored"><td><p>Original Status:</p></td><td><p :style="{ 'color': setPassColor(quizInfo.summary.passed), 'font-weight': 700 }">{{ quizInfo.summary.passed ? 'Passed' : 'Failed' }}</p></td></tr>
            <tr v-else><td><p>Status:</p></td><td><p :style="{ 'color': setPassColor(quizInfo.summary.passed), 'font-weight': 700 }">{{ quizInfo.summary.passed ? 'Passed' : 'Failed' }}</p></td></tr>

            <tr v-if="newScore != info.marksScored"><td><p>New Score:</p></td><td><p style="font-weight: 700">{{ newScore }}</p></td></tr>
            
            <tr v-if="newScore != info.marksScored"><td><p>New Percentage:</p></td><td><p style="font-weight: 700">{{ (newScore*100)/quizInfo.quizSettings.maxScore }}%</p></td></tr>

            <tr v-if="(newScore != info.marksScored) && (quizInfo.quizSettings.passingPercent > 0) && (((newScore*100)/quizInfo.quizSettings.maxScore) > quizInfo.quizSettings.passingPercent)"><td><p>New Status:</p></td><td><p style="color: #28c76f; font-weight: 700">Passed</p></td></tr>
            <tr v-else-if="(newScore != info.marksScored) && (quizInfo.quizSettings.passingPercent > 0) && (((newScore*100)/quizInfo.quizSettings.maxScore) < quizInfo.quizSettings.passingPercent)"><td><p>New Status:</p></td><td><p style="color: #ea5455; font-weight: 700">Failed</p></td></tr> -->
            
            <tr><td><p>Time Finished:</p></td><td><p style="font-weight: 700">{{ quiz.timeFinished.replace("T", " ").split('.')[0] }}</p></td></tr>
          </table>
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
  export default {
    components: {
      
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      info: {
        type: Object,
        required: false
      },
      quiz: {
        type: Object,
        required: false
      },
      newScore: {
        type: Number,
        required: false
      },
      freeTextTotal: {
        type: Number,
        required: false
      },
      newQuizTotal: {
        type: Number,
        required: false
      },
    },
    data() {
      return {
        quizDescription: ""
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            this.$emit("closeCard");
            this.initValues();
          }
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          if(self.question){

          }else{
            self.initValues();
          }
        }
      },
      question: function(val) {
        if(val){
          this.commentView = true;
        }
      }
    },
    methods: {
      strip(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
      },
      setColor(val) {
        if(val){
          return '#28c76f';
        }
        else{
          return 'orange';
        }
      },
      setOptionFont(optionIndex, option, answer) {
        if((optionIndex + 1) == answer.inputAnswer && answer.inputAnswer == option.optionNumber.toString())
          return 700;
        else if((optionIndex + 1) == answer.inputAnswer && answer.inputAnswer != option.optionNumber.toString())
          return 700;
        else
          return 400;
      },
      saveData() {
        this.initValues();
        this.$emit('saveData');
      },
      initValues() {
        
        this.errors.clear();
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
      },
      scrollToFooter() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -480,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("footerGlobal"), 100, scrollOptions);
      },
    },
    mounted() {
      if(this.quiz){
        this.quizDescription = this.strip(this.quiz.description);
      }
    }
  }

</script>

<style lang="scss">

</style>
